import { CapitalizeFirstPipe } from 'src/app/pipe/capitalize-pipe/capitalize-first.pipe';
import { CharacterLimitPipe } from 'src/app/pipe/ui-chs-statusbar/character-limit.pipe';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MinutesToHourminPipe } from 'src/app/pipe/minutes-to-hourmin.pipe';
import { SanitizeModule } from '../sanitize.module';
import { SeparatePascalCasePipe } from 'src/app/pipe/separate-pascal-case.pipe';
import { SvgInlinePipe } from 'src/app/pipe/svg-inline/svg-inline.pipe';
import { StripTagsPipe } from 'src/app/pipe/strip-tags/strip-tags.pipe';
import { RemoveSpacePipe } from 'src/app/pipe/remove-space/remove-space.pipe';
import { FormatLocaleDatePipe } from 'src/app/pipe/format-locale-date/format-locale-date.pipe';
import { HtmlTextPipe } from 'src/app/pipe/html-text/html-text.pipe';
import { FormatIfDatetimeOrTranslateDefaultPipe } from 'src/app/pipe/format-if-datetime-or-translate-default/format-if-datetime-or-translate-default';
import { TranslateDefaultValueIfNotFoundPipe } from 'src/app/pipe/translate-default-value-if-not-found/translate-default-value-if-not-found.pipe';
import { FormatLocaleDateTimeFullPipe } from 'src/app/pipe/format-locale-datetime/format-locale-datetime-full.pipe';
import { FormatLocaleDateTimePipe } from 'src/app/pipe/format-locale-datetime/format-locale-datetime.pipe';

@NgModule({
	declarations: [
		CapitalizeFirstPipe,
		CharacterLimitPipe,
		MinutesToHourminPipe,
		SeparatePascalCasePipe,
		HtmlTextPipe,
		SvgInlinePipe,
		StripTagsPipe,
		FormatLocaleDatePipe,
		RemoveSpacePipe,
		FormatIfDatetimeOrTranslateDefaultPipe,
		FormatLocaleDateTimePipe,
		FormatLocaleDateTimeFullPipe,
		TranslateDefaultValueIfNotFoundPipe,
	],
	exports: [
		CapitalizeFirstPipe,
		CharacterLimitPipe,
		MinutesToHourminPipe,
		SanitizeModule,
		SeparatePascalCasePipe,
		HtmlTextPipe,
		SvgInlinePipe,
		StripTagsPipe,
		SanitizeModule,
		FormatLocaleDatePipe,
		RemoveSpacePipe,
		FormatIfDatetimeOrTranslateDefaultPipe,
		FormatLocaleDateTimePipe,
		FormatLocaleDateTimeFullPipe,
		TranslateDefaultValueIfNotFoundPipe,
	],
	imports: [SanitizeModule],
	providers: [FormatLocaleDatePipe, FormatLocaleDateTimePipe, FormatLocaleDateTimeFullPipe],
	entryComponents: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CommonPipeModule {}
